import { render } from "./SharedHeader.vue?vue&type=template&id=6b121d7d"
import script from "./SharedHeader.vue?vue&type=script&lang=js"
export * from "./SharedHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__